import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import {
  monthOptions,
  yearOptions,
} from "../../../dashboardLevelMekanikSA/dasboardLaporanHarianPartByMekanikdanSA/config";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { configMonthToDateMekanik, tableConfig } from "./config";
import moment from "moment";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { buildExcelRequestBodyJualPartMTD } from "../configExcel";
import { saveAs } from "file-saver";

// type = part || by_cabang
export default class LaporanMTD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
      menuName: null,
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
      menuName: "LAPORAN JUAL PART MONTH TO DATE",
    }));
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading();

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanSalesPartMTD,
        setError: this.props.setError,
        menuName: "Dashboard Level Kabeng Keatas - Laporan Jual Part MTD",
        args: {
          kodeCabang: this.props.search,
          year: this.state.year?.value,
          month: this.state.month?.value,
        },
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const rawData = res.data.data || [];
        const totalRow = rawData.find(
          (item) => item.partCategory?.toLowerCase() === "total",
        );

        const detailRows = rawData.filter(
          (item) => item.partCategory?.toLowerCase() !== "total",
        );
        const orderedData = totalRow ? [totalRow, ...detailRows] : detailRows;

        const mappedData = orderedData.map((item) => ({
          partCategory:
            item.partCategory?.toLowerCase() === "total"
              ? "TOTAL"
              : item.partCategory,

          lastMonthValue: Number(item.lastMonthValue || 0),
          thisMonthValue: Number(item.thisMonthValue || 0),
          growthPercent: Number(item.growthPercent || 0),
          projectionSales: Number(item.projectionSales || 0),
        }));

        this.setState({
          tableConfig: configMonthToDateMekanik,
          dataTable: mappedData,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.props.triggerLoading();
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    const { month, year, dataTable, mekanik } = this.state;
    this.props.triggerLoading();

    try {
      const reqBody = buildExcelRequestBodyJualPartMTD({
        month,
        year: year.value,
        dataTable
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName:
          "Dashboard Level Kabeng Keatas - Laporan Jual Part MTD",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      this.props.triggerLoading();
    }
  };

  render() {
    const { month, year, dataTable, menuName } = this.state;
    return (
      <React.Fragment>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={this.handleSearch}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <p className="margin-bottom-20px">{menuName}</p>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton text="CETAK" onClick={() => this.handlePrint()} />
        </FlexView>
      </React.Fragment>
    );
  }
}
